import { R7E_IApplication, r7eBaseApp, R7eAccountTypeError, R7E_NavBarData, R7E_HomeItem } from '@r7e/shared';

class R7E_PublisherApplication extends R7E_IApplication {
    constructor(app) {
        super('publisher', app)
        // console.log('R7E_PublisherApplication', this);
    }

    // --- NavBar Setup ---

    getNavBarData() {
        const nav = new R7E_NavBarData(this, 'navbar_publisher.publisher');
        nav.setItemsBuilder((curr) => {
            const app = curr.app;
            const b = app.base.hasAccessToCurrentService();
            const items = [
                // { route: "/info", title_id: 'navbar_publisher.publisherInfo', condition: b },
                { route: "/contents", title_id: 'navbar_publisher.contents', description: 'navbar_publisher.contentsDesc', icon: 'fa-solid fa-list', condition: b },
                { route: "/claims", title_id: 'navbar_publisher.claims', description: 'navbar_publisher.claimsDesc', icon: 'fa-solid fa-file-alt', condition: b },
                { route: "/reports/", title_id: 'navbar_publisher.reports', description: 'navbar_publisher.reportsDesc', icon: 'fa-solid fa-chart-bar', condition: b },
                { route: "/receipts", title_id: 'navbar_publisher.receipts', description: 'navbar_publisher.receiptsDesc', icon: 'fa-solid fa-file-invoice-dollar', condition: b },
                { route: "/logs/", title_id: 'navbar_publisher.logs', description: 'navbar_publisher.logsDesc', icon: 'fa-solid fa-file-alt', condition: b },
                { route: "/transactions", title_id: 'navbar_publisher.transactions', description: 'navbar_publisher.transactionsDesc', icon: 'fa-solid fa-money-bill', condition: b, experiment: 'transaction' }
            ];
            return items;
        });
        return nav;
    }
    // --- end of NavBar Setup ---

    getHomeItems() {
        const row1 = [];

        const contents = new R7E_HomeItem(this, 'home_publisher.myContents', 'home_publisher.myContentsDescription', '/contents');
        contents.setIcon('fa-solid fa-list');
        contents.setCSSClass('box-contents');
        contents.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(contents);

        const reports = new R7E_HomeItem(this, 'home_publisher.myReports', 'home_publisher.myReportsDescription', '/reports');
        reports.setCSSClass('box-reports');
        reports.setIcon('fa-solid fa-chart-bar');
        reports.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(reports);
        // reports.setSVG(require('@/assets/svg/reports.svg'));

        const accountInfo = new R7E_HomeItem(this, 'home_publisher.myAccount', 'home_publisher.myAccountDescription', '/account');
        accountInfo.setIcon('fa-solid fa-user');
        accountInfo.setCSSClass('box-account-info');
        accountInfo.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(accountInfo);

        // const row2 = [];
        // const recognyze_contents = new R7E_HomeItem(this, 'home_publisher.recognyzeContents', 'home_publisher.recognyzeContentsDescription', '/contents/new');
        // recognyze_contents.setIcon('fa-solid fa-list');
        // recognyze_contents.setCSSClass('box-recognyze-contents');
        // recognyze_contents.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        // row2.push(recognyze_contents);


        // const logs = new R7E_HomeItem(this, 'Logs', 'View your logs', '/logs');
        // logs.setIcon('fa-solid fa-file-alt');
        // logs.setCSSClass('box-logs');
        // logs.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        // row2.push(logs);        

        // return [row1, row2];
        return [row1];

    }

    getAvailableExperimentations() {
        const availableExperimentations = super.getAvailableExperimentations();
        availableExperimentations.push('transactions');
        return availableExperimentations;
    }

    getProfileFieldsSettings() {
        const profile_fields = super.getProfileFieldsSettings();
        // profile_fields.push(
        //     { key: 'area_of_interest', label: 'areaOfInterest', type: 'text', required: true }
        // )
        return profile_fields;
    }

    setupPages() { return super.setupPages().concat(["/contents"]); }


    // --- Account Endpoints ---

    async getCredit(accountId) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`account/publisher/${encodeURIComponent(accountId)}/pending-credit`);
            return response.data;
        } catch (error) {
            return { pending_credit: 0, is_fake: true }; // TODO: remove this	
            // return { pending_credit: 12005, is_fake: true }; // TODO: remove this	
            // console.error("Error fetching credit:", error.response ? error.response.data : error.message);
            // throw error;
        }
    }

    async getPublisherReceipts(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const account = await this.base.getAccount();
            const publisherId = account?.id || this.getUsername();
            const response = await this.base.apiR7eClient.get(`publisher/${encodeURIComponent(publisherId)}/receipts/`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching publisher receipts:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getPublisherReceiptConsumersList(publisherId, startDate, endDate, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`publisher/${publisherId}/receipts/${startDate}/${endDate}/consumers/`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching receipt data list:", error.response ? error.response.data : error.message);
            throw error;
        }
    } 

    async getPublisherReceiptById(receiptId) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const account = await this.base.getAccount();
            const publisherId = account?.id || this.getUsername();
            const response = await this.base.apiR7eClient.get(`billing/publisher/${encodeURIComponent(publisherId)}/receipts/${encodeURIComponent(receiptId)}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching publisher receipt:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    // --- Content Endpoints ---
    async getPublisherContents(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get('publisher/contents/', { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching contents:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getReportsPeriods(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get('publisher/reports/periods/', { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching reports:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    // --- Bot Rules ---
    async getBotRules() {
        // console.log('getBotRules...');
        const CACHE_KEY = 'r7e_bot_rules';
        const CACHE_TS_KEY = 'r7e_bot_rules_ts';
        const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

        try {
            const cachedTs = localStorage.getItem(CACHE_TS_KEY);
            const cachedRules = localStorage.getItem(CACHE_KEY);
            if (cachedTs && cachedRules && Date.now() - Number(cachedTs) < TTL_MS) {
                // console.log('getBotRules... returning cached rules');
                // console.log('getBotRules... cached rules', JSON.parse(cachedRules));
                return JSON.parse(cachedRules);
            }
        } catch {
            // ignore parse error, re-fetch
        }

        try {
            // console.log('getBotRules... fetching from API');
            const response = await this.base.apiR7eClient.get('bot-rules');
            // console.log('getBotRules... response', response);
            const rules = response.data;
            try {
                localStorage.setItem(CACHE_KEY, JSON.stringify(rules));
                localStorage.setItem(CACHE_TS_KEY, String(Date.now()));
            } catch {
                // localStorage full or unavailable – ignore
            }
            return rules;
        } catch (error) {
            console.warn('getBotRules: API unavailable, falling back to bundled rules.', error?.message);
            // Fallback: return any stale cache rather than nothing
            try {
                const stale = localStorage.getItem(CACHE_KEY);
                if (stale) return JSON.parse(stale);
            } catch { /* ignore */ }
            // Final fallback: import bundled static file
            const { default: bundled } = await import('../config/ua_rules.json');
            return bundled;
        }
    }

    // --- Logs Endpoints ---
    async getLogYears(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get('publisher/logs/', { params });
            // console.log('getLogYears response', response);
            return response?.data?.data?.years;
        } catch (error) {
            console.error("Error fetching log years:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getLogMonths(year, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`publisher/logs/${encodeURIComponent(year)}/`, { params });
            // console.log('getLogMonths response', response);
            return response?.data?.data?.months;
        } catch (error) {
            console.error("Error fetching log months:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getLogDays(year, month, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`publisher/logs/${encodeURIComponent(year)}/${encodeURIComponent(month)}/`, { params });
            // console.log('getLogDays response', response);
            return response?.data?.data?.days;
        } catch (error) {
            console.error("Error fetching log days:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getLogEntries(year, month, day, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const rq_params = {
            };
            if (params) {
                if ('limit' in params) {
                    rq_params.size = params.limit;
                } else {
                    rq_params.size = 100;
                }
                if ('offset' in params) {
                    rq_params.offset = params.offset;
                } else {
                    rq_params.offset = 0;
                }
            }
            const response = await this.base.apiR7eClient.get(`publisher/logs/${encodeURIComponent(year)}/${encodeURIComponent(month)}/${encodeURIComponent(day)}/`, { params: rq_params });
            // console.log('getLogEntries response', response);
            // console.log('getLogEntries response data', response?.data?.data);
            return response?.data?.data;
        } catch (error) {
            console.error("Error fetching log entries:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getPublisherContent(identifier, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`publisher/content/${encodeURIComponent(identifier)}`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getPublicContent(identifier, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`store/content/${encodeURIComponent(identifier)}`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async searchAuthors(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get('authors/search', { params });
            return response.data;
        } catch (error) {
            console.error("Error searching authors:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async discoverWebsite(payload) {
        await this.base.auth.refreshTokenIfNeeded();
        // console.log('discoverWebsite...', website);

        try {
            // const formData = new FormData();
            // if (discoveryMode === 'website') {
            //     formData.append('url', url);
            // } else if (discoveryMode === 'sitemap') {
            //     formData.append('url', url);
            // } else if (discoveryMode === 'urlset') {
            //     formData.append('url', url);
            //     formData.append('urlset', payload);
            // }
            // formData.append('discovery_mode', discoveryMode);
            const response = await this.base.apiR7eClient.post('publisher/discovery/', payload);
            // formData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data'
            //     }
            // });
            return response.data;
        } catch (error) {
            console.error("Error discovering website:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    normalizeContentData(contentData) {
        // console.log('normalizeContentData', contentData);
        var payload = {};
        if ('name' in contentData && contentData.name) {
            payload.name = contentData.name;
        }
        if ('price' in contentData) {
            payload.price = parseInt(contentData.price);
        }
        if ('authors' in contentData && contentData.authors) {
            payload.authors = contentData.authors;
        }
        if ('publication_urls' in contentData && contentData.publication_urls) {
            payload.publication_urls = contentData.publication_urls;
        }
        if ('size' in contentData && contentData.size) {
            payload.size = contentData.size;
        }
        if ('collection_name' in contentData && contentData.collection_name) {
            payload['collection'] = contentData.collection_name;
        }
        if ('tags' in contentData && contentData.tags) {
            payload.tags = contentData.tags;
        }

        payload.items = contentData.items || {};
        for (const i in contentData) {
            if (i.startsWith('item_')) {
                const i_name = i.replace('item_', '');
                if (i_name == 'collection') {
                    payload.collection = contentData[i];
                } else if (i_name == 'tags') {
                    payload.tags = contentData[i];
                } else if (!(i_name in payload['items'])) {
                    payload.items[i_name] = contentData[i];
                }
            } else if (!(i in payload)) {
                payload[i] = contentData[i];
            }
        }

        if ('tags' in payload && payload.tags) {
            if (Array.isArray(payload.tags)) {
                // Keep the array as is
            } else {
                // Convert the string to an array
                if (payload.tags === '') {
                    payload.tags = null;
                } else {
                    payload.tags = payload.tags.split(',');
                }
            }
        }
        if ('authors' in payload && payload.authors) {
            if (Array.isArray(payload.authors)) {
                // Keep the array as is
            } else {
                // Convert the string to an array
                if (payload.authors === '') {
                    payload.authors = null;
                } else {
                    payload.authors = payload.authors.split(',');
                }
            }
            /* Clean empty authors */
            const to_remove = [];
            for (const author of payload.authors) {
                if (author.name === '') {
                    author.name = author.account_id;
                    to_remove.push(author);
                } else {
                    // Remove any field from author that starts with '_'
                    for (const key in author) {
                        if (key.startsWith('_')) {
                            delete author[key];
                        }
                    }
                }
            }
            for (const author of to_remove) {
                payload.authors.splice(payload.authors.indexOf(author), 1);
            }
        }
        if ('publication_urls' in payload && payload.publication_urls) {
            if (Array.isArray(payload.publication_urls)) {
                // Keep the array as is
            } else {
                // Convert the string to an array
                if (payload.publication_urls === '') {
                    payload.publication_urls = null;
                } else {
                    payload.publication_urls = payload.publication_urls.split(',');
                }
            }
        }

        if (!('name' in payload) || !payload.name) {
            var url = null;
            if (payload.publication_urls && payload.publication_urls.length > 0) {
                url = payload.publication_urls[0];
                payload.name = url.split('/').pop();
                console.log('Use publication URL to set name:', payload.name);
            }

            // throw new Error('Name is required. Publication URLs are provided, but name is not. Please provide a name for the content.');
        }
        // console.log('normalizeContentData result', payload);
        return payload;
    }

    async recognyzeNewContent(contentData) {
        await this.base.auth.refreshTokenIfNeeded();
        // Map form data to the NewContent schema
        var payload = this.normalizeContentData(contentData);
        // console.log('recognyzeNewContent with payload', payload);
        try {
            const response = await this.base.apiR7eClient.post('publisher/content/', payload);
            return response.data;
        } catch (error) {
            console.error("Error recognyzing new content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async recognyzeNewContents(contentDataList) {
        await this.base.auth.refreshTokenIfNeeded();
        // Map form data to the NewContent schema
        var payload = { version: "0.1", contents: [] };
        for (const contentData of contentDataList) {
            var payloadItem = this.normalizeContentData(contentData);
            // console.log('contentData', contentData, payloadItem);
            payload.contents.push(payloadItem);
        }
        // console.log('recognyzeNewContents with payload', payload);
        try {
            const response = await this.base.apiR7eClient.post('publisher/contents/', payload);
            return response.data;
        } catch (error) {
            console.error("Error recognyzing new contents:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async updateContent(identifier, contentData) {
        await this.base.auth.refreshTokenIfNeeded();
        // Map form data to the NewContent schema
        var payload = this.normalizeContentData(contentData);
        try {
            const response = await this.base.apiR7eClient.put(`publisher/content/${encodeURIComponent(identifier)}?include=content`, payload);
            return response.data;
        } catch (error) {
            console.error("Error updating content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async unrecognyzeContent(identifier) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.delete(`publisher/content/${encodeURIComponent(identifier)}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async unrecognyzeContents(identifiers) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.delete('publisher/contents/', {
                data: { identifiers },
                headers: { 'Content-Type': 'application/json' }
            });
            return response.data;
        } catch (error) {
            console.error("Error bulk deleting contents:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async addAuthorToSelectedContents(author, identifiers) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            for (const identifier of identifiers) {
                const content = await this.getPublisherContent(identifier);
                // console.log('content', content);
                const authors = []
                let found = false;
                let content_authors = null;
                if (content?.authors && content.authors.length > 0) {
                    content_authors = content.authors;
                } else if (content?.items?.authors && content.items?.authors.length > 0) {
                    content_authors = content.items.authors;
                } else {
                    content_authors = [];
                }
                if (content_authors) {
                    for (const a of content_authors) {
                        if (a.id === author.id) {
                            found = true;
                        }
                        //   console.log('author', a);
                        authors.push(a);
                    }
                }
                if (!found) {
                    const newAuthor = { id: author.id };
                    if (author.name) {
                        newAuthor.name = author.name;
                    }
                    if (author.orcid) {
                        newAuthor.orcid = author.orcid;
                    }
                    authors.push(newAuthor);
                }
                // console.log('new authors', authors);
                // const response = 
                await this.base.apiR7eClient.put(`publisher/content/${encodeURIComponent(identifier)}/authors/`, authors);
                // console.log('response', response);
            }
            return { success: true, message: 'Author added to selected contents' };
        } catch (error) {
            console.error("Error adding author to selected contents:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    // --- Claim Request Endpoints ---
    // FIXME: Add endpoints for claim request

    async getPublisherClaims(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get('publisher/claims/', { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching publisher claims:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getClaimRequest(claim_id) {
        await this.base.auth.refreshTokenIfNeeded();
        // console.log('getClaimRequest', claim_id);
        try {
            // const account_id = this.getUsername(); // FIXME: it should use a author id, not the current publisher id
            // const response = await this.base.apiR7eClient.get(`publisher/${encodeURIComponent(account_id)}/claim/${encodeURIComponent(claim_id)}`);
            const response = await this.base.apiR7eClient.get(`publisher/claim/${encodeURIComponent(claim_id)}`);
            // console.log('getClaimRequest response', response);
            return response.data;
        } catch (error) {
            console.error("Error fetching claim request:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async acceptClaimRequest(identifier) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.post(`publisher/claim/${encodeURIComponent(identifier)}/accept`);
            return response.data;
        } catch (error) {
            console.error("Error accepting claim request:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async rejectClaimRequest(identifier) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.post(`publisher/claim/${encodeURIComponent(identifier)}/reject`);
            return response.data;
        } catch (error) {
            console.error("Error rejecting claim request:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getReportById(a_report_id, extension = '') {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`publisher/report/${encodeURIComponent(a_report_id)}${extension ? `.${extension}` : ''}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching report by report id:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getAgentReportByPeriodId(a_report_id, a_agent_id, extension = '') {
        // console.log('getAgentReportById', a_report_id, a_agent_id);
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`publisher/report/${encodeURIComponent(a_report_id)}/agent/${encodeURIComponent(a_agent_id)}${extension ? `.${extension}` : ''}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching report by report id:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

}

export { R7eAccountTypeError, R7E_PublisherApplication, r7eBaseApp };
export default { ...R7eAccountTypeError, R7E_PublisherApplication, r7eBaseApp }